import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';

const AUTOMATICALLY_VERIFIED = 'AUTOMATICALLY_VERIFIED';
const VERIFICATION_FAILED = 'VERIFICATION_FAILED';

interface PublicTokenRequest {
  elevate_account_id: number | string;
  status: string;
}

const useSubmitPlaidBankAccountActivationQuery = () => {
  const { mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (data: PublicTokenRequest) => api.post(PATHS.ACTIVATE_PLAID_BANK_ACCOUNT, data),
    {
      retry: 0,
    }
  );

  const updateBankStatus = useCallback(
    async (data: Omit<PublicTokenRequest, 'status'>) => {
      await mutateAsync({
        elevate_account_id: data.elevate_account_id,
        status: AUTOMATICALLY_VERIFIED,
      });
    },
    [mutateAsync]
  );

  const updateFailedBankStatus = useCallback(
    async (data: Omit<PublicTokenRequest, 'status'>) => {
      await mutateAsync({
        elevate_account_id: data.elevate_account_id,
        status: VERIFICATION_FAILED,
      });
    },
    [mutateAsync]
  );

  return {
    updateBankStatus,
    updateFailedBankStatus,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useSubmitPlaidBankAccountActivationQuery;
